module.exports = __webpack_public_path__ + "static/media/virgen-coromoto.98af0fe8.jpg";